import React from 'react'

export default function SignInAgreePolicy() {
  return (
    <div className="text-sm text-gray-600 text-center">
      By signing up, you are agreeing to our <br />
      <a
        target="_blank"
        rel="noreferrer"
        href="https://hydrascore.com/terms-and-conditions"
        className="text-primary hover:underline"
      >
        Terms of Use
      </a>{' '}
      and{' '}
      <a
        target="_blank"
        rel="noreferrer"
        href="https://hydrascore.com/privacy-policy/"
        className="text-primary hover:underline"
      >
        Privacy Policy
      </a>
      .
    </div>
  )
}
